import React from 'react';
import { InputProps } from '..';
import SVG from '../../SVG';
import * as S from './styled'
import InputCheckboxGroup from './InputCheckboxGroup';

export interface FormInputCheckProps extends InputProps {
  label?: string;
  loading?: boolean;
}

 function InputCheckbox({
  label,
  checked,
  onChange,
  className,
  style,
  loading = false,
  disabled,
  ...rest
}: FormInputCheckProps) {
  const handleOnChange = (e: any) => {
    if (!loading) onChange && onChange(e);
  };
  return (
    <S.CheckboxWrapper className={className} style={style} disabled={disabled}>
      <S.CheckboxInput
        type="checkbox"
        onChange={handleOnChange}
        checked={checked}
        disabled={disabled}
        {...rest}
      />
      {loading ? (
        <SVG.Icon.Loader width={25} height={25} />
      ) : (
        <S.CheckboxCheckmark />
      )}
      <S.CheckboxLabel disabled={disabled}>{label}</S.CheckboxLabel>
    </S.CheckboxWrapper>
  );
}

export default Object.assign(InputCheckbox, {
  Group: InputCheckboxGroup
})